'use es6';

export const ACTION_CHOICE_RESET = 'CHOICE_RESET';
export const ACTION_STATE_UPDATED = 'CHOICE_UPDATED';
export const ACTION_HUB_OPT_IN = 'HUB_OPT_IN';
export const ACTION_HUB_OPT_OUT = 'HUB_OPT_OUT';
export const ACTION_INIT_OPT = 'INIT_OPT';
export const ACTION_USER_OPT_IN = 'USER_OPT_IN';
export const ACTION_USER_OPT_OUT = 'USER_OPT_OUT';